import { render, staticRenderFns } from "./IconCloseCircle.vue?vue&type=template&id=6d519812&"
import script from "./IconCloseCircle.vue?vue&type=script&lang=js&"
export * from "./IconCloseCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d519812')) {
      api.createRecord('6d519812', component.options)
    } else {
      api.reload('6d519812', component.options)
    }
    module.hot.accept("./IconCloseCircle.vue?vue&type=template&id=6d519812&", function () {
      api.rerender('6d519812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCloseCircle.vue"
export default component.exports